import axios from "axios";

const getSliders = async () => {
	try {
		const response = await axios.get(
			`${process.env.REACT_APP_API_URL}/sliders`
		);
		const sliders = response.data.slide;
		if (response.status !== 200 || !sliders) {
			throw new Error("Error al obtener los sliders");
		}
		return sliders;
	} catch (e) {
		throw new Error("Error al obtener los sliders");
	}
};

export default getSliders;
